module.exports = __webpack_public_path__ + "bd2d76b59298619044b6cff9d7f8c20a.jpg";